const ORGANIZATION_INCIDENT_CREATED = 'organizationIncidentCreated';

export {ORGANIZATION_INCIDENT_CREATED}